import React from 'react'
import type { HTMLAttributes, MouseEvent } from 'react'
import dialogStyles from '../primitives/dialog.module.css'
import { CloseButton } from './close-button.js'
import styles from './dialog-title.module.css'

export interface DialogTitleProps extends HTMLAttributes<HTMLDivElement> {
  id?: string
  controls?: React.ReactNode
  children?: React.ReactNode
  /** Renders the × close button; without it, the dialog closes only through its own actions and Escape */
  onClose?: (ev: MouseEvent) => void
}

export const DialogTitle = ({
  id,
  title,
  children,
  controls = null,
  onClose,
  className,
  style,
  ...rest
}: DialogTitleProps) => {
  const classes = [dialogStyles.title, styles.root, className].filter(Boolean).join(' ')
  return (
    <div className={classes} style={style} {...rest}>
      {/* The id labels the dialog, so it wraps only the title — not the controls or the close button */}
      <div id={id}>
        {title ? <span className={styles.titleText}>{title}</span> : null}
        {children}
      </div>
      {controls}
      {onClose ? <CloseButton onClose={onClose} /> : null}
    </div>
  )
}

export default DialogTitle
